export function isAndroid () {
  // return window.navigator.userAgent.indexOf('Android') > 0;
  // return (window.navigator.userAgent || '').toLowerCase().includes('android')
  return (window.cordova && window.cordova.platformId && window.cordova.platformId === 'android' && window.cordova.version !== 'N/A')
}

export function isBrowser () {
  // return true
  return !isAndroid() && !isiOS()
}

export function isiOS () {
  // return (window.navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('iPad') > 0 || navigator.userAgent.indexOf('iPod') > 0);
  // const userAgent = (window.navigator.userAgent || '').toLowerCase()
  // return (userAgent.includes('iphone') || userAgent.includes('ipad') || userAgent.includes('ipod') || userAgent.includes('ios'))
  return (window.cordova && window.cordova.platformId && window.cordova.platformId === 'ios' && window.cordova.version !== 'N/A')
}



// WEBPACK FOOTER //
// ./src/utils/DeviceInfoHelper.js